import { Injectable, signal } from '@angular/core';

/**
 * UI-state service for the AI Assistant overlay panel.
 *
 * Decouples the toggle triggers (header button, Ctrl+Shift+A, FAB) from the shell host
 * (layout) so neither needs a direct reference to the other. Holds only open/closed state.
 */
@Injectable({ providedIn: 'root' })
export class AiChatPanelService {
    readonly isOpen = signal(false);

    open(): void {
        this.isOpen.set(true);
    }

    close(): void {
        this.isOpen.set(false);
    }

    toggle(): void {
        this.isOpen.update((open) => !open);
    }
}
